import { render, staticRenderFns } from "./ArchiveAddForm.vue?vue&type=template&id=4cdd92c4&"
import script from "./ArchiveAddForm.vue?vue&type=script&lang=js&"
export * from "./ArchiveAddForm.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports